var _mask, _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 241,
    viewBox: "0 0 510 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_499_218",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00973e-05 115.5C8.77133e-06 130.668 2.98751 145.687 8.79195 159.7C14.5964 173.713 23.1041 186.446 33.8293 197.171C44.5545 207.896 57.2872 216.404 71.3004 222.208C85.3135 228.013 100.333 231 115.5 231L115.5 178.401C107.24 178.401 99.0604 176.774 91.4289 173.613C83.7973 170.452 76.8631 165.819 71.0221 159.978C65.1812 154.137 60.5479 147.203 57.3868 139.571C54.2257 131.94 52.5987 123.76 52.5987 115.5L1.00973e-05 115.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00973e-05 115.5C8.77133e-06 130.668 2.98751 145.687 8.79195 159.7C14.5964 173.713 23.1041 186.446 33.8293 197.171C44.5545 207.896 57.2872 216.404 71.3004 222.208C85.3135 228.013 100.333 231 115.5 231L115.5 178.401C107.24 178.401 99.0604 176.774 91.4289 173.613C83.7973 170.452 76.8631 165.819 71.0221 159.978C65.1812 154.137 60.5479 147.203 57.3868 139.571C54.2257 131.94 52.5987 123.76 52.5987 115.5L1.00973e-05 115.5Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_499_218)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 432,
    y1: 240,
    x2: 510,
    y2: 240,
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.914161be1e91936a95cbc02fd9f26e30.svg";
export { ForwardRef as ReactComponent };